import apiClients from "../api/axiosConfig";

export const getFooterNotes = (country) =>
    apiClients.feesAPI.get(`/api/v1/document-footer-notes/${country}`);

export const updateFooterNotes = async (request) =>
    apiClients.feesAPI.put(`/api/v1/document-footer-notes/`, request);

export const createFooterNote = async (request) =>
    apiClients.feesAPI.post(`/api/v1/document-footer-notes/`, request);

export const rearrangeFooterNotes = async(request) =>
    apiClients.feesAPI.put(`/api/v1/document-footer-notes/rearrange/`, request);

export const deleteFooterNotes = async (request) =>
    apiClients.feesAPI.put(`/api/v1/document-footer-notes/`, request);